module.exports = __webpack_public_path__ + "static/media/logo-ploneconf.2271a2a6.png";